module.exports = __webpack_public_path__ + "img/hook_PEWAG_FW_2.9ba449d3.png";